import { useState, useEffect } from 'react';
import { VideoItem, VideoDetailsModal } from '../components/VideoCarousel/VideoCarouselModal';
import { NotificationSection } from '../components/Notification/NotificationSection';
import { DeeplinkCreatedModal } from '../components/Notification/DeeplinkCreatedModal';
import { usePushDeeplinkSearch } from '../hooks/usePushDeeplinkSearch';
import { useFotbollPlaySubmit } from '../api/FotbollPlaySubmitProvider';

interface NotificationTabProps {
  teamAbbrv: string;
}

export function NotificationTab({ teamAbbrv }: NotificationTabProps) {
  const { searchQuery, setSearchQuery, searchResults, isSearching } =
    usePushDeeplinkSearch(teamAbbrv);
  const [moreInfoVideo, setMoreInfoVideo] = useState<VideoItem | null>(null);
  const [isDeeplinkModalOpen, setIsDeeplinkModalOpen] = useState(false);
  const [createdDeeplink, setCreatedDeeplink] = useState('');
  const { registerTabPayload } = useFotbollPlaySubmit();

  useEffect(() => {
    return registerTabPayload(3, () => ({}));
  }, [registerTabPayload]);

  function handleCreateDeeplink(item: VideoItem) {
    setCreatedDeeplink(`https://app.example.com/video/${item.id}` /* placeholder */);
    setIsDeeplinkModalOpen(true);
  }

  return (
    <>
      <NotificationSection
        teamAbbrv={teamAbbrv}
        searchQuery={searchQuery}
        isSearching={isSearching}
        searchResults={searchResults}
        onSearchQueryChange={setSearchQuery}
        onMoreInfo={setMoreInfoVideo}
        onCreateDeeplink={handleCreateDeeplink}
      />

      <VideoDetailsModal
        open={!!moreInfoVideo}
        onClose={() => setMoreInfoVideo(null)}
        video={moreInfoVideo}
      />

      <DeeplinkCreatedModal
        open={isDeeplinkModalOpen}
        deeplink={createdDeeplink}
        onClose={() => setIsDeeplinkModalOpen(false)}
      />
    </>
  );
}
